import "./ACS.css"

function ACS() {
    return (
        <section id="acs">
            <div className="sectionBox">
                <div className="acs">
                    <nav className="#acs">
                        <h1>
                            IEC 62443 Certified Consultancy
                        </h1>
                        <p>
                            Offering consultancy services, guidance and support for IEC 62443 implementation including:                       
                        </p>
                        <ul>
                            <li>Initial Risk Assessment</li>
                            <li>Gap Analyses for e.g. IEC 62443-2-1, -3-3, or -4-1</li>
                            <li>Zones and Conduits Security Architecture and Network Design</li>
                            <li>Secure Development Lifecycle Assurance </li>
                        </ul>
                    </nav>
                </div>
            </div>
        </section>
    )
}

export default ACS